module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lIbNj"))).then(() => parcelRequire('fThBo'));